$('.js-items__inputs-area--textarea').on('input', function(){
  let maxlength = $(this).attr("maxlength");
  let currentLength = $(this).val().length;

  // Change current character length
  $('.js-items__inputs-area--span').find('#current').text(currentLength);
  
  // Change current character color when reach max limit
  if( currentLength >= maxlength ){
    $('.js-items__inputs-area--span').css({'color' : '#e95c49'});
  } else {
    $('.js-items__inputs-area--span').css({'color' : '#cdd0d8'});
  }
});